import { environment } from "src/environments/environment";

export class GlobalVariable {
   public static BASE_API_URL = environment.backEndConfig.baseApiUrl;
   public static MP_URL = environment.backEndConfig.baseApiUrl;
   public static BASE_CSV_URL = environment.backEndConfig.baseCsvUrl;
   public static GMAP_API_KEY = environment.backEndConfig.mapApi;
   public static SESSION_ENC_KEY = environment.backEndConfig.sessionKey;
   public static BASE_UI_URL = environment.backEndConfig.baseUiUrl;
   public static currencyList  = {
      DOLLAR:'$',
      RUPEE:'₹'
   }
   public static CURRENCY = this.currencyList.DOLLAR;
   // public static BASE_UI_URL = 'http://localhost:4200/';
};
